import Enum from "../../../enums/Enum";

const EnumAppointmentReportStatus = new Enum({
    PENDING: {name: "Pending", bgColor: "#FFA500", textColor: "#ffffff", cutBgColor: "#FFB520", order: 1},
    FINAL: {name: "Reported", bgColor: "#3B86FF", textColor: "#ffffff", cutBgColor: "#5B96FF", order: 2},
    ADDENDUM: {name: "Addendum", bgColor: "#4CAF50", textColor: "#ffffff", cutBgColor: "#6CBF70", order: 3}
});



export default EnumAppointmentReportStatus;